var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "go-form-member go-form-login" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.step == 1
        ? _c("div", { staticClass: "go-form-body" }, [
            _c("div", { staticClass: "go-display-header" }, [
              _c("div", { staticClass: "go-display-text" }, [
                _c("h2", { staticClass: "go-display-h2" }, [
                  _vm._v(_vm._s(_vm.$t("register.agreeTerm"))),
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "go-display-sub",
                  domProps: {
                    textContent: _vm._s(_vm.$t("register.agreeTerm2")),
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-area" },
              [
                _c("div", { staticClass: "custom-control custom-checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.isSelectAll,
                        expression: "isSelectAll",
                      },
                    ],
                    staticClass: "custom-control-input",
                    attrs: { type: "checkbox", id: "customCheck-all" },
                    domProps: {
                      checked: Array.isArray(_vm.isSelectAll)
                        ? _vm._i(_vm.isSelectAll, null) > -1
                        : _vm.isSelectAll,
                    },
                    on: {
                      click: _vm.toggleAll,
                      change: function ($event) {
                        var $$a = _vm.isSelectAll,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.isSelectAll = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.isSelectAll = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.isSelectAll = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", {
                    staticClass: "custom-control-label",
                    attrs: { for: "customCheck-all" },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("register.terms.all")),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "hr-t1" }),
                _vm._v(" "),
                _vm._l(_vm.purposes, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "go-form-group-between" },
                    [
                      _c(
                        "div",
                        { staticClass: "custom-control custom-checkbox" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.policies,
                                expression: "policies",
                              },
                            ],
                            staticClass: "custom-control-input",
                            attrs: {
                              type: "checkbox",
                              id: "customCheck-" + item.id,
                            },
                            domProps: {
                              value: item.id,
                              checked: Array.isArray(_vm.policies)
                                ? _vm._i(_vm.policies, item.id) > -1
                                : _vm.policies,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.policies,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = item.id,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.policies = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.policies = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.policies = $$c
                                  }
                                },
                                _vm.toggleSelect,
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c("label", {
                            staticClass: "custom-control-label",
                            attrs: { for: "customCheck-" + item.id },
                            domProps: {
                              innerHTML: _vm._s(_vm.$t(item.purposeName)),
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      item.url
                        ? _c(
                            "button",
                            {
                              staticClass: "go-btn-view",
                              attrs: {
                                "data-toggle": "modal",
                                "data-target": item.url,
                              },
                            },
                            [
                              _c("span", { staticClass: "go-text" }, [
                                _vm._v(_vm._s(_vm.$t("register.terms.detail"))),
                              ]),
                              _vm._v(" "),
                              _vm._m(1, true),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "go-btn-area" }, [
                  _c("button", {
                    staticClass: "btn btn-lg go-btn-next w-100",
                    attrs: {
                      type: "button",
                      disabled: !_vm.areAllRequiredIdsPresent(),
                      id: "js-btn-next2",
                    },
                    domProps: {
                      textContent: _vm._s(_vm.$t("register.form.next")),
                    },
                    on: { click: _vm.nextStep },
                  }),
                ]),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.step == 2
        ? _c("div", { staticClass: "go-form-body" }, [
            _c("div", { staticClass: "go-display-header" }, [
              _c("div", { staticClass: "go-display-text" }, [
                _c("h2", {
                  staticClass: "go-display-h2",
                  staticStyle: { "font-size": "1.4rem" },
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("register.betaMessage.enterInfor")
                    ),
                  },
                }),
                _vm._v(" "),
                _c("p", { staticClass: "go-display-sub" }, [
                  _vm._v(_vm._s(_vm.$t("register.betaMessage.enterInfor2"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-form-area" }, [
              _c("ul", { staticClass: "nav go-tab-line" }, [
                _c("li", { staticClass: "go-tab-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "go-tab-link",
                      class: [
                        "go-tab-link",
                        _vm.selectedLogin === 0 ? "active" : "",
                      ],
                      attrs: {
                        "data-toggle": "tab",
                        "data-target": "#go-id-phone-2",
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleTypeLogin(0)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("register.phone.phone")))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "go-tab-item",
                    attrs: { role: "presentation" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "go-tab-link",
                        class: [
                          "go-tab-link",
                          _vm.selectedLogin === 1 ? "active" : "",
                        ],
                        attrs: {
                          "data-toggle": "tab",
                          "data-target": "#go-id-email-2",
                          type: "button",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleTypeLogin(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("register.phone.email")))]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tab-content" }, [
                _c(
                  "div",
                  {
                    class: [
                      "tab-pane fade",
                      _vm.selectedLogin === 0 ? "show active" : "",
                    ],
                    attrs: { id: "go-id-phone-2" },
                  },
                  [
                    _vm.selectedLogin === 0
                      ? _c("div", { staticClass: "go-form-group" }, [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-checkbox" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.isAcceptOTP,
                                    expression: "isAcceptOTP",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "customCheck-5",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.isAcceptOTP)
                                    ? _vm._i(_vm.isAcceptOTP, null) > -1
                                    : _vm.isAcceptOTP,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.isAcceptOTP,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.isAcceptOTP = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.isAcceptOTP = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.isAcceptOTP = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "custom-control-label",
                                  attrs: { for: "customCheck-5" },
                                },
                                [
                                  _c("span", {
                                    staticClass: "go-label-info",
                                    staticStyle: { "word-break": "keep-all" },
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t("register.betaMessage.form.sms")
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.isAcceptOTP
                            ? _c("div", { staticClass: "go-form-feedback" }, [
                                _c(
                                  "div",
                                  { staticClass: "go-form-feedback-invalid" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "register.betaMessage.form.warnAcceptOTP"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-group" }, [
                      _c("label", { staticClass: "go-form-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("register.betaMessage.form.selectCountry")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.countrySelect,
                              expression: "countrySelect",
                            },
                          ],
                          staticClass: "go-form-control",
                          attrs: { disabled: !_vm.isAcceptOTP },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.countrySelect = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: { disabled: "", selected: "" },
                              domProps: { value: null },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("myPage.profile.selectPhoneCountry")
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.countries, function (country) {
                            return _c(
                              "option",
                              {
                                key: country.label,
                                domProps: { value: country.value },
                              },
                              [_vm._v(_vm._s(country.label))]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.phoneTxt &&
                      _vm.phoneTxt.length > 0 &&
                      _vm.countrySelect === null
                        ? _c(
                            "small",
                            { staticClass: "form-text text-danger" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "myPage.profile.requiredPhoneCountry"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-group" }, [
                      _c("label", {
                        staticClass: "go-form-label",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("register.betaMessage.form.phoneId")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phoneTxt,
                              expression: "phoneTxt",
                            },
                          ],
                          staticClass: "go-form-control",
                          attrs: {
                            type: "tel",
                            placeholder: _vm.$t(
                              "register.betaMessage.form.enterValidPhone"
                            ),
                            maxlength: "40",
                            disabled: _vm.isSendingCode || !_vm.isAcceptOTP,
                          },
                          domProps: { value: _vm.phoneTxt },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.phoneTxt = $event.target.value
                              },
                              _vm.checkRegexPhone,
                            ],
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.getVerificationCode("phoneInput")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-input-group-append" }, [
                          _c("button", {
                            staticClass: "btn go-btn-outline-primary",
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                            },
                            attrs: {
                              type: "button",
                              disabled:
                                _vm.isSendingCode ||
                                !_vm.phoneTxt.length ||
                                !_vm.checkRegexPhone() ||
                                !_vm.isAcceptOTP ||
                                !_vm.countrySelect ||
                                _vm.countrySelect === null,
                            },
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("register.betaMessage.form.btnSend")
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.getVerificationCode("phoneInput")
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      !_vm.phoneTxt.length && _vm.isTypeWithPhoneInput
                        ? _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "register.betaMessage.form.enterPhone"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          )
                        : (!_vm.checkRegexPhone() &&
                            _vm.isTypeWithPhoneInput) ||
                          _vm.isInCorrectPhone
                        ? _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "register.betaMessage.form.invalidPhone"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm.existedMailOrPhone
                        ? _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("register.betaMessage.form.existPhone")
                                )
                              ),
                            ]
                          )
                        : _vm.isShowResentCodeForPhone
                        ? _c("div", { staticClass: "go-form-feedback" }, [
                            _c(
                              "div",
                              { staticClass: "go-form-feedback-valid" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "register.betaMessage.form.resendPhoneCode.codeSent"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "go-info-box" }, [
                              _c("div", { staticClass: "go-info-title" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t(
                                        "register.betaMessage.form.resendPhoneCode.notGotCode"
                                      )
                                    )
                                ),
                                _c(
                                  "a",
                                  {
                                    class: {
                                      notAllowClick:
                                        _vm.isSendingCode ||
                                        !_vm.phoneTxt.length ||
                                        !_vm.checkRegexPhone() ||
                                        !_vm.isAcceptOTP,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getVerificationCode(
                                          "phoneInput"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "register.betaMessage.form.resendPhoneCode.resend"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("ul", { staticClass: "go-info-list" }, [
                                _c("li", { staticClass: "go-list-item" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "register.betaMessage.form.resendPhoneCode.checkCorrectPhone"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "go-list-item" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "register.betaMessage.form.resendPhoneCode.checkSpamMessage"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      "tab-pane fade",
                      _vm.selectedLogin === 1 ? "show active" : "",
                    ],
                    attrs: { id: "go-id-email-2" },
                  },
                  [
                    _c("div", { staticClass: "go-form-group" }, [
                      _c("label", { staticClass: "go-form-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("register.betaMessage.form.emailId"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.mailTxt,
                              expression: "mailTxt",
                            },
                          ],
                          staticClass: "go-form-control",
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t(
                              "register.betaMessage.form.enterEmail"
                            ),
                            maxlength: "40",
                            disabled: _vm.isSendingCode,
                          },
                          domProps: { value: _vm.mailTxt },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.mailTxt = $event.target.value
                              },
                              _vm.checkRegexEmail,
                            ],
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.stopPropagation()
                              return _vm.getVerificationCode("emailInput")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-outline-primary",
                              attrs: {
                                type: "button",
                                disabled:
                                  _vm.isSendingCode ||
                                  !_vm.mailTxt.length ||
                                  _vm.isInvalidMailOrPhone,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.getVerificationCode("emailInput")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t("register.betaMessage.form.btnSend")
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      !_vm.mailTxt.length && _vm.isTypeWithMailInput
                        ? _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "register.betaMessage.form.enterEmail2"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm.isInvalidMailOrPhone
                        ? _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "register.betaMessage.form.invalidEmail"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm.existedMailOrPhone
                        ? _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "register.betaMessage.form.existEmail"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm.isShowResentCodeForEmail
                        ? _c("div", { staticClass: "go-form-feedback" }, [
                            _c(
                              "div",
                              { staticClass: "go-form-feedback-valid" },
                              [_vm._v(_vm._s(_vm.$t("register.sentCode")))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "go-info-box" }, [
                              _c("div", { staticClass: "go-info-title" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t(
                                        "register.betaMessage.form.notReceiveCode"
                                      )
                                    )
                                ),
                                _c(
                                  "a",
                                  {
                                    class: {
                                      notAllowClick:
                                        _vm.isVerificationCodeSuccess &&
                                        _vm.isSendingCode,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getVerificationCode(
                                          "emailInputResendCode"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("register.resend")))]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("ul", { staticClass: "go-info-list" }, [
                                _c("li", { staticClass: "go-list-item" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "register.betaMessage.form.resendEmailCode.checkCorrectEmail"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "go-list-item" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "register.betaMessage.form.resendEmailCode.checkSpamMessage"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "go-list-item" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "register.betaMessage.form.resendEmailCode.checkMailboxCapacity"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-form-group" }, [
                _c("label", {
                  staticClass: "go-form-label",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("register.betaMessage.form.enterCode")
                    ),
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "go-input-group" }, [
                  _c("div", { staticClass: "go-input-group-floating" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.confirmCode,
                          expression: "confirmCode",
                        },
                      ],
                      staticClass: "go-form-control",
                      staticStyle: { "padding-right": "5rem" },
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t(
                          "register.betaMessage.form.enterCode2"
                        ),
                        maxlength: "6",
                        disabled:
                          _vm.isVerificationCodeSuccess && _vm.isSendingCode,
                      },
                      domProps: { value: _vm.confirmCode },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.confirmCode = $event.target.value
                          },
                          _vm.checkRegexCode,
                        ],
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.confirm()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.isSendingCode
                      ? _c("div", { staticClass: "go-form-timer" }, [
                          _vm._v(
                            _vm._s(_vm.minLeft) + ":" + _vm._s(_vm.secLeft)
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-outline-primary",
                        attrs: {
                          type: "button",
                          disabled:
                            !_vm.isSendingCode ||
                            !_vm.checkRegexCode() ||
                            _vm.confirmCode.length < 6 ||
                            (_vm.isVerificationCodeSuccess &&
                              _vm.isSendingCode) ||
                            (!_vm.isVerificationCodeSuccess &&
                              _vm.sendedVerificationCode &&
                              _vm.isSendingCode &&
                              !_vm.isReConFirmCode),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.confirm()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("register.betaMessage.form.verifyCode")
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                !_vm.confirmCode.length && _vm.isSendingCode
                  ? _c("div", { staticClass: "go-form-feedback-invalid" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("register.betaMessage.form.verifyCode2")
                          ) +
                          "\n        "
                      ),
                    ])
                  : (!_vm.checkRegexCode() || _vm.confirmCode.length) < 6 &&
                    _vm.isSendingCode
                  ? _c("div", { staticClass: "go-form-feedback-invalid" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("register.betaMessage.form.invalidCode")
                          ) +
                          "\n        "
                      ),
                    ])
                  : _vm.isExpiredCode
                  ? _c("div", { staticClass: "go-form-feedback-invalid" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("register.betaMessage.form.expiredCode")
                          ) +
                          "\n        "
                      ),
                    ])
                  : _vm.isVerificationCodeSuccess && _vm.isSendingCode
                  ? _c("div", { staticClass: "go-form-feedback-valid" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("register.betaMessage.form.validCode")
                          ) +
                          "\n        "
                      ),
                    ])
                  : !_vm.isVerificationCodeSuccess &&
                    _vm.sendedVerificationCode &&
                    _vm.isSendingCode &&
                    !_vm.isReConFirmCode
                  ? _c("div", { staticClass: "go-form-feedback-invalid" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("register.betaMessage.form.invalidCode")
                          ) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-form-group" }, [
                _c("label", { staticClass: "go-form-label" }, [
                  _vm._v(_vm._s(_vm.$t("register.betaMessage.form.name"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.registerFormModel.lastName,
                      expression: "registerFormModel.lastName",
                    },
                  ],
                  staticClass: "go-form-control",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("register.betaMessage.form.enterName"),
                  },
                  domProps: { value: _vm.registerFormModel.lastName },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.registerFormModel,
                          "lastName",
                          $event.target.value
                        )
                      },
                      _vm.checkValidName,
                    ],
                  },
                }),
                _vm._v(" "),
                (!_vm.registerFormModel.lastName || !_vm.isValidName) &&
                _vm.isTypeWithName
                  ? _c("div", { staticClass: "go-form-feedback-invalid" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("register.betaMessage.form.enterName")
                          ) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-btn-area" }, [
                _c("button", {
                  staticClass: "btn go-btn-prev",
                  attrs: { type: "button" },
                  domProps: {
                    textContent: _vm._s(_vm.$t("register.form.back")),
                  },
                  on: { click: _vm.handleBackStep },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-next",
                    attrs: {
                      type: "button",
                      disabled:
                        !_vm.isVerificationCodeSuccess ||
                        !_vm.registerFormModel.lastName ||
                        (_vm.selectedLogin === 0 &&
                          (!_vm.isAcceptOTP || !_vm.phoneTxt)) ||
                        (_vm.selectedLogin === 1 && !_vm.mailTxt) ||
                        !_vm.isValidName ||
                        _vm.waitingReceivingApi,
                    },
                    on: { click: _vm.handleReceiving },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("register.form.completeSignUp")) +
                        "\n          "
                    ),
                    _vm.waitingReceivingApi
                      ? _c("b-spinner", {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { small: "", label: "Small Spinner" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.step == 3
        ? _c("div", { staticClass: "go-form-body" }, [
            _c("div", { staticClass: "go-display-header" }, [
              _c("div", { staticClass: "go-display-text go-media-md-up" }, [
                _c("h2", { staticClass: "go-display-h2" }, [
                  _vm._v(_vm._s(_vm.$t("register.betaMessage.regisComplete"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "go-display-sub" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("register.betaMessage.regisComplete2")) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-display-text go-media-sm-down" }, [
                _c("h2", {
                  staticClass: "go-display-h2",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("register.betaMessage.thankYou")
                    ),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "go-display-sub",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("register.betaMessage.introduceGooverMobile")
                    ),
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-form-area" }, [
              _vm.registerFormModel.countryCode
                ? _c("div", { staticClass: "go-form-group" }, [
                    _c("label", { staticClass: "go-form-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("register.betaMessage.form.selectCountry")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.registerFormModel.countryCode,
                          expression: "registerFormModel.countryCode",
                        },
                      ],
                      staticClass: "go-form-control-plaintext",
                      attrs: { type: "text", readonly: "" },
                      domProps: { value: _vm.registerFormModel.countryCode },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registerFormModel,
                            "countryCode",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "go-form-group" }, [
                _c("label", { staticClass: "go-form-label" }, [
                  _vm._v(_vm._s(_vm.$t("register.betaMessage.id"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.registerFormModel.login,
                      expression: "registerFormModel.login",
                    },
                  ],
                  staticClass: "go-form-control-plaintext",
                  attrs: { type: "text", readonly: "" },
                  domProps: { value: _vm.registerFormModel.login },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.registerFormModel,
                        "login",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-form-group" }, [
                _c("label", { staticClass: "go-form-label" }, [
                  _vm._v(_vm._s(_vm.$t("register.betaMessage.form.name"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.registerFormModel.lastName,
                      expression: "registerFormModel.lastName",
                    },
                  ],
                  staticClass: "go-form-control-plaintext",
                  attrs: { type: "text", readonly: "" },
                  domProps: { value: _vm.registerFormModel.lastName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.registerFormModel,
                        "lastName",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-form-group" }, [
                _c("label", { staticClass: "go-form-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("register.betaMessage.memberDate")) + " "
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "go-form-control-plaintext",
                  attrs: { type: "text", readonly: "" },
                  domProps: { value: _vm.convertDateToCustomFormat() },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-btn-block" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg go-btn-login",
                    attrs: { type: "button", disabled: _vm.waitingRegisterApi },
                    on: { click: _vm.handleCheckbox },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("register.phone.start")) +
                        "\n          "
                    ),
                    _vm.waitingRegisterApi
                      ? _c("b-spinner", {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { small: "", label: "Small Spinner" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "go-form-footer" }, [
        _c("ul", { staticClass: "go-fnb" }, [
          _c("li", { staticClass: "go-nav-item" }, [
            _c(
              "a",
              {
                staticClass: "go-nav-link",
                attrs: { href: "https://goover.ai/", target: "_blank" },
              },
              [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("register.betaMessage.introduceGoover"))
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "go-nav-item" }, [
            _c(
              "button",
              {
                staticClass: "go-nav-link",
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#termOfUseModal",
                },
              },
              [_vm._v(_vm._s(_vm.$t("footerGlobal.term-of-service")))]
            ),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "go-nav-item" }, [
            _c(
              "button",
              {
                staticClass: "go-nav-link",
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#policyModal",
                },
              },
              [_vm._v(_vm._s(_vm.$t("footerGlobal.privacy-policy")))]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("terms-of-use"),
      _vm._v(" "),
      _c("privacy-policy"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-form-header" }, [
      _c("div", { staticClass: "go-brand" }, [
        _c("div", { staticClass: "go-brand-symbol" }, [
          _c("img", {
            attrs: {
              src: "content/images/images_v3/common/go-goover-symbol.png",
              alt: "goover symbol",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-brand-logo" }, [
          _c("img", {
            attrs: {
              src: "content/images/images_v3/common/goover_logo.png",
              alt: "goover logo",
            },
          }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-icon" }, [
      _c("i", { staticClass: "go-icon-20 go-icon-chevron-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }